import { render } from "./Slider.vue?vue&type=template&id=20cbe0c8&scoped=true"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"

import "@/assets/scss/_slider.scss?vue&type=style&index=0&id=20cbe0c8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20cbe0c8"]])

export default __exports__